import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export enum OperatingSystem {
  windowsX64 = 'windows_x64',
  windowsARM = 'windows_arm',
  macos = 'macos',
}

export interface InstallationDownloadResponse {
  fileUrl: string;
}

@Injectable({
  providedIn: 'root',
})
export class InstallationDownloadHttpService {
  private readonly _httpClient = inject(HttpClient);
  private readonly _baseUrl = `${environment.api_base_url}/${environment.api_version}`;
  private readonly _downloadUrl = `${this._baseUrl}/installation/download`;

  public getDownloadUrl(os: OperatingSystem): Observable<InstallationDownloadResponse> {
    return this._httpClient.get<InstallationDownloadResponse>(`${this._downloadUrl}?os=${os}`);
  }
}
